import React from 'react';
import { IconProps } from './types';

const PlusSquare: React.FC<IconProps> = ({
  size = 32,
  color = '#181B32',
  ignoreColor,
  className,
}) => {
  const pluSquareIconId = String(Date.now());

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={!ignoreColor ? color : undefined}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11h-2V9c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z"
      />
      <mask
        id={`icon-${pluSquareIconId}`}
        maskUnits="userSpaceOnUse"
        x={3}
        y={3}
        width={18}
        height={18}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 11h-2V9c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z"
          fill={!ignoreColor ? color : undefined}
        />
      </mask>
      <g mask={`url(#icon-${pluSquareIconId})`}>
        <path fill={!ignoreColor ? color : undefined} d="M0 0h24v24H0z" />
      </g>
    </svg>
  );
};

export default PlusSquare;
